import axios from './axios';

const baseUrl = '/purchases-expenses-periods';

async function request(method, url, data, params) {
    const response = await axios({
        method,
        url,
        headers: { 'content-type': 'application/json' },
        data,
        params
    });

    if (!response.data || !response.data.success) {
        const error = new Error((response.data && response.data.message) || 'No fue posible completar la operación.');
        error.response = response;
        throw error;
    }

    return response.data;
}

export default {
    getPeriods(params) {
        return request('GET', baseUrl, null, params);
    },
    getHistory(params) {
        return request('GET', `${baseUrl}/history`, null, params);
    },
    open(data) {
        return request('POST', `${baseUrl}/open`, data);
    },
    close(data) {
        return request('POST', `${baseUrl}/close`, data);
    },
    reopen(data) {
        return request('POST', `${baseUrl}/reopen`, data);
    }
};
